// What percentage of the maximum length if allowed before the character count will display.
export const THRESHOLD = 0.7;
